import { render } from "./BoxTotalEntrance.vue?vue&type=template&id=e868814a"
import script from "./BoxTotalEntrance.vue?vue&type=script&lang=js"
export * from "./BoxTotalEntrance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__